import React, { useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import i18next from "i18next";

interface LanguageProtectorProps {
  children: React.ReactNode;
}

const LanguageProtector: React.FC<LanguageProtectorProps> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.loading && !auth.currentUser && i18next.language === "it") {
      console.log("🚫 Acceso a italiano bloqueado - Forzando español");
      i18next.changeLanguage("es");
    }
  }, [auth.currentUser, auth.loading]);

  return <>{children}</>;
};

export default LanguageProtector;
